/**
 * Bid form that listens for the given posts bid events.
 *
 * @param {object} param0
 * @param {int} param0.postId
 * @param {string} param0.postName
 * @param {string} param0.nickname
 * @param {int} param0.amount
 * @param {string} param0.latestBidderNickname
 * @returns {object}
 */
export default function ({ postId, postName, nickname, amount, latestBidderNickname }) {
    return {
        postId,
        postName,
        nickname,
        amount,
        latestBidderNickname,
        submit: function (guest = false, identified = true) {
            if (guest) {
                window.livewire.emit('guestLoginModal@show');
                return;
            }

            if (!identified) {
                window.livewire.emit('userIdentificationModal@show');
                return;
            }

            window.livewire.emit('postBidModal@show', {
                amount: this.amount,
                name: this.postName,
                own_bid: this.nickname == this.latestBidderNickname,
            });
        },
        mounted: function () {
            window.Echo.channel('post-bids.' + this.postId).listen('Bids.BidCreated', (event) => {
                this.latestBidderNickname = event.nickname;
            });
        },
    };
}
